import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const GarageIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 22 20" fill="none" {...props}>
    <g clipPath="url(#clip0_13727_5245)">
      <path
        d="M21.9209 -0.0996094C21.9761 -0.0996094 22.0215 -0.0552285 22.0215 0V3.66992C22.0235 3.67789 22.0264 3.68573 22.0264 3.69434C22.0264 3.73562 22.0015 3.77087 21.9658 3.78613L21.9268 3.79492H20.6611C20.6667 8.76695 20.667 13.739 20.667 18.7109V19.5781C20.6668 19.6331 20.6224 19.6776 20.5674 19.6777H1.34863C1.29352 19.6777 1.24823 19.6332 1.24805 19.5781V18.7109C1.24808 18.6913 1.25486 18.6736 1.26465 18.6582V3.79492H0C-0.0552285 3.79492 -0.0996094 3.74956 -0.0996094 3.69434V0C-0.0996094 -0.0552285 -0.0552285 -0.0996094 0 -0.0996094H21.9209ZM2.37305 18.6113H4.04004V5.11621C4.04028 5.06119 4.08555 5.0166 4.14062 5.0166H17.8818C17.9369 5.0166 17.9821 5.06118 17.9824 5.11621C17.9937 7.38275 18.0059 9.6479 18.0186 11.9131C18.0311 14.1453 18.0435 16.3778 18.0547 18.6113H19.5586C19.5585 16.142 19.5565 13.6726 19.5537 11.2031C19.5509 8.73385 19.5479 6.26427 19.5479 3.79492H2.37305V18.6113ZM5.04199 18.6113H16.9697V14.3555H5.04199V18.6113ZM5.04199 13.1387H16.9756V11.6113H5.04199V13.1387ZM5.04688 10.4004H16.9697V8.84473H5.04688V10.4004ZM5.04688 7.62793H16.9697V6.11133H5.04688V7.62793ZM1.00781 2.7002H20.9131V0.994141H1.00781V2.7002Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.2"
        strokeLinejoin="round"
      />
    </g>

    <defs>
      <clipPath id="clip0_13727_5245">
        <rect width="22" height="20" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
